module.exports = __webpack_public_path__ + "static/media/wind.3285b0f9.svg";